module.exports = __webpack_public_path__ + "static/media/partnerslogo_bg_mobile.0dad0459.png";